export default [
    {
        path: '/v2/fee-predefine-item',
        name: 'fee-predefine-item',
        meta: { requiresAuth: true },
        component: () => import('./views/index.vue')
    }
]
